import { GetProfileState } from './getProfile.types'

const initialState: GetProfileState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
